import { useState } from 'react';
import { QuestionnaireAPI } from "../../../../../../services/api";


const AlarmBrake = () => {
  const [showText, setShowText] = useState(false);

  const handleMouseEnter = () => {
    setShowText(true);
  };

  const handleMouseLeave = () => {
    setShowText(false);
  };
  const handleAlarmClick = async () => {
    await QuestionnaireAPI.requestPause();
  };

  return (
    <>
      <div style={{ position: 'relative', display: 'inline-block' }}>
            <div
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <button
                onClick={handleAlarmClick}
                className="alarm-button"
                style={{ fontSize: '2em', backgroundColor: '#333' }}
              >
                🚨
              </button>
              {showText && (
                <div
                  style={{
                    position: 'absolute',
                    top: '30px', // Adjust this value to move the text box relative to the button
                    left: '50%',
                    transform: 'translateX(-50%)',
                    padding: '3px',
                    backgroundColor: '#fff',
                    border: '1px solid #333',
                    borderRadius: '4px',
                    color: '#000',
                    fontSize: '0.8em',
                  }}
                >
                  אזעקה
                </div>
              )}
            </div>
      </div>
    </>
  );
};

export { AlarmBrake };
